module.exports = __webpack_public_path__ + "img/nedir-03.0f04b1f9.svg";